import React from 'react';
import InputForm from './InputForm';
import NavbarCompWithoutLogin from './NavBarCompWithoutLogin';
export default function AddNumber(){
    return(
        <React.Fragment>
            <NavbarCompWithoutLogin/>
            <InputForm/>
        </React.Fragment>
    )
}